<article
  class="list-card"
  [style.--accent]="accent"
  [class.is-collapsed]="isCollapsed"
>
  <div class="header">
    <div class="header-text">
      <h3>{{ title }}</h3>
      <small *ngIf="subtitle">{{ subtitle }}</small>
    </div>
    <button
      type="button"
      class="toggle-icon-btn"
      [attr.aria-expanded]="!isCollapsed"
      [attr.aria-label]="
        (isCollapsed
          ? 'dashboard.list.expand_table'
          : 'dashboard.list.collapse_table'
        ) | translate
      "
      (click)="toggleCollapsed()"
    >
      <mat-icon>{{ isCollapsed ? 'expand_more' : 'expand_less' }}</mat-icon>
    </button>
  </div>
  <div class="divider"></div>

  <div class="table-wrap" *ngIf="!isCollapsed">
    <qs-table [data]="tableRows" [columns]="columns"></qs-table>
  </div>
  <div class="collapsed-state" *ngIf="isCollapsed">
    {{ 'dashboard.list.rows_hidden' | translate: { count: tableRows.length } }}
  </div>
</article>
